<template>
  <div>
    <v-row no-gutters class="form-group" v-if="!noLabel">
      <span v-if="label !== ''" class="item-label">{{ label }}</span>
      <span v-else class="item-label" style="color:white" />
      <label class="form-group-label">
        <span v-if="required && !requiredMarkHidden" class="mandatory">必須</span>
      </label>
    </v-row>
    <v-row no-gutters class="py-0 range-style" :style="'margin-top: 1px; background-color:' + (required && !readonly ? '#FFEDEE;' : 'white;') + (readonly ? 'border-bottom: 1px solid #1F2B38' : 'border: 1px solid #CDD6DD; border-radius:5px;')">
      <v-col class="py-0 d-flex" :cols="12">
        <div class="pl-0" style="display: inline-block; width:40%; min-width: 105px;">
          <dd-time-box-inside
            v-on="computedListeners"
            v-bind="computedProps"
            v-model="innerFromTime"
            label=""
            ref="fromTime"
            :readonly="readonly"
            :required="required || requiredFrom"
            :placeholder="phtext"
            :tabindex="readonly ? -1 : 0"
            :isOuterErrorMessage="true"
            :outerErrorMessage.sync="fromErrorMessage"
          />
        </div>
        <div class="pl-1 pr-0 pt-1" style="display: inline-block;">～</div>
        <div class="px-0" style="display: inline-block;width:40%; min-width: 105px;">
          <dd-time-box-inside
            v-on="computedListeners"
            v-bind="computedProps"
            v-model="innerToTime"
            label=""
            ref="toTime"
            :readonly="readonly"
            :required="required || requiredTo"
            :placeholder="phtext"
            :tabindex="readonly ? -1 : 0"
            :isOuterErrorMessage="true"
            :outerErrorMessage.sync="toErrorMessage"
          />
        </div>
      </v-col>
    </v-row>
    <div class="range-style-message-area error--text" v-if="fromErrorMessage || toErrorMessage">
      <div class="range-style-message" style="width: calc(40% + 14.11px); min-width: calc(111px + 14.11px);">
        {{ ![undefined, null].includes(fromErrorMessage) ? fromErrorMessage : '' }}
      </div>
      <div class="range-style-message" style="flex-grow: 1; flex-basis: 0;">
        {{ ![undefined, null].includes(toErrorMessage) ? toErrorMessage : '' }}
      </div>
    </div>
  </div>
</template>
<script>
import { VTextField } from 'vuetify/lib'
import controls from '@/rahmen/controls'
import inputMixin from '@/mixins/inputMixins'
// import date from '@/ddv2.library/date'

// import DdCustomButton from '@/components/DdCustomButton'
import DdTimeBoxInside from '@/components/DdTimeBoxInside'
// import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
// import DdTransparentButton from '@/components/DdTransparentButton'

/**
 * @file DDv2用日付入力
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [required=false] - 必須有無
 * @vue-prop {String} [max='']- 許容最大値(デフォルト:2999/12/31)
 * @vue-prop {String} [min=''] - 許容最小値(デフォルト:2000/01/01)
 * @vue-prop {String} [errorMessages=''] - エラーメッセージ
 * @see https://vuetifyjs.com/ja/api/v-text-field/
 * @example
  <dd-date-box
    label="適用開始日"
    v-model="dateValue"
    max="2099/12/31"
    min="2000/01/01"/>
 */
export default {
  name: 'DdDateRangeBox',
  extends: VTextField,
  components: {
    // DdCustomButton,
    DdTimeBoxInside
    // DdIconButtonWithTooltip,
    // DdTransparentButton
  },
  mixins: [inputMixin],
  props: {
    /**
     * ラベル
     */
    label: String,
    /*
     * From日付
     */
    fromTime: {
      type: String,
      default: ''
    },
    /**
     * To日付
     */
    toTime: {
      type: String,
      default: ''
    },
    /**
     * 必須指定
     */
    required: {
      type: Boolean,
      default: false
    },
    /**
     * 必須指定(FROMのみ)
     * Required優先
     */
    requiredFrom: {
      type: Boolean,
      default: false
    },
    /**
     * 必須指定(TOのみ)
     * Required優先
     */
    requiredTo: {
      type: Boolean,
      default: false
    },
    /**
     * 入力可能最大値
     */
    max: String,
    /**
     * 入力可能最小値
     */
    min: String,
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String,
    /**
     * タイトル表示
     */
    no_title: {
      type: Boolean,
      default: true
    },
    /**
     * ツールチップテキスト
     */
    tooltipText: {
      type: String,
      default: ''
    },
    /**
     * ツールチップ表示要否
     */
    enableToolTip: {
      type: Boolean,
      default: true
    },
    /**
     * ツールチップ表示位置（左）
     */
    tooltipLeft: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（上）
     */
    tooltipTop: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（右）
     */
    tooltipRight: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（下）
     */
    tooltipBottom: {
      type: Boolean,
      default: false
    },
    /**
     * ラベル不要
     */
    noLabel: {
      type: Boolean,
      default: false
    },
    /**
     * 必須マーク非表示
     */
    requiredMarkHidden: {
      type: Boolean,
      default: false
    },
    /**
     * defaultPickerType
     * 00:期間,01:From,02:To
     */
    defaultPickerType: {
      type: String,
      default: '00'
    },
    /**
     * 使用モード
     * ---------------------------------------------
     * 選択時のラジオボタンの表記が変わります。
     * 未指定時は検索用
     * ---------------------------------------------
     */
    useMode: {
      type: String,
      default: 'search'
    },
    /**
     * 月単位の値変更ボタンを表示
     */
    dispMonthJumper: {
      type: Boolean,
      default: false
    },
    /**
     * vc-date-picker:is-required
     * falseにすると、単一選択カレンダーで同じ値をクリックしたとき値が消える
     * (範囲選択は無関係)
     */
    calendarIsRequired: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    phtext: '',
    hasFocus: false,
    invalidMessage: '',
    isShowCalendar: false,
    defaultMax: '2999/12/31',
    defaultMin: '2000/01/01',
    // pickerType: '00',
    selectedMode: 0,
    calendarRangeDate: { start: null, end: null },
    selectedFrom: null,
    modelConfig: {
      type: 'string',
      mask: 'HH24/MI/SS'
    },
    locale: {
      masks: {
        input: 'HH24/MI/SS'
      }
    },

    fromErrorMessage: '',
    toErrorMessage: ''
  }),
  computed: {
    computedProps () {
      return {
        ...this.$props
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    innerFromTime: {
      get () {
        return this.fromTime
      },
      set (value) {
        if (value !== this.fromTime) this.$emit('change', value, this.toTime)
        this.$emit('update:fromTime', value)
      }
    },
    innerToTime: {
      get () {
        return this.toTime
      },
      set (value) {
        if (value !== this.toTime) this.$emit('change', this.fromTime, value)
        this.$emit('update:toTime', value)
      }
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    [controls.SET_INVALID_METHOD]: function (message) {
      this.$refs.fromTime[controls.SET_INVALID_METHOD](message)
      this.$refs.toTime[controls.SET_INVALID_METHOD](message)
    },
    [controls.GET_INVALID_METHOD]: function () {
      const result = (this.$refs.fromTime[controls.GET_INVALID_METHOD]() ?? '') + (this.$refs.toTime[controls.GET_INVALID_METHOD]() ?? '')
      return result !== '' ? result : undefined
    },
    [controls.CLEAR_INVALID_METHOD]: function () {
      this.$refs.fromTime[controls.CLEAR_INVALID_METHOD]()
      this.$refs.toTime[controls.CLEAR_INVALID_METHOD]()
    },
    [controls.VALIDATE_METHOD]: function () {
      this.$refs.fromTime[controls.VALIDATE_METHOD]()
      this.$refs.toTime[controls.VALIDATE_METHOD]()
    }
  }
}
</script>
<style scoped>
.range-style {
  height:32px !important;
  overflow: hidden;
}
.range-style-message-area {
  display: flex;
  margin: 0 1px;
}
.range-style-message {
  font-size: 12px;
  line-height: 12px;
  word-break: break-word;
  overflow-wrap: break-word;
  word-wrap: break-word;
  -webkit-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
  padding: 2px 4px 2px 12px;
}
</style>
